import { useNavigate } from "react-router-dom";
import "./LandingPage.css";
import { clearDemoSession } from "../utils/demoAuth";

function LandingPage() {
  const navigate = useNavigate();

  const openLogin = () => {
    clearDemoSession();
    navigate("/login");
  };

  const openDemo = () => {
    clearDemoSession();
    navigate("/demo-login");
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const navHeight = document.querySelector(".landing-nav")?.offsetHeight || 0;
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: Math.max(sectionTop - navHeight - 24, 0),
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="landing-page">
      <div className="landing-shell">
        <nav className="landing-nav" aria-label="FinoraAI navigation">
          <button type="button" className="landing-brand" onClick={() => navigate("/")}>
            <span className="landing-brand-mark">F</span>
            <span className="landing-brand-copy">
              <strong>FinoraAI</strong>
              <small>Your Personal AI Fin Advisor</small>
            </span>
          </button>

          <div className="landing-nav-links">
            <button type="button" onClick={() => scrollToSection("features")}>
              Features
            </button>
            <button type="button" onClick={() => scrollToSection("ai-insights")}>
              AI Insights
            </button>
            <button type="button" onClick={() => scrollToSection("ocr-scanner")}>
              OCR Scanner
            </button>
            <button type="button" onClick={() => scrollToSection("reports")}>
              Reports
            </button>
          </div>

          <div className="landing-actions">
            <button type="button" className="landing-button secondary" onClick={openLogin}>
              Login
            </button>
            <button type="button" className="landing-button primary" onClick={openDemo}>
              Try Live Demo
            </button>
          </div>
        </nav>

        <main className="landing-hero">
          <section id="features">
            <span className="landing-kicker">AI-powered personal finance cockpit</span>
            <h1>
              FinoraAI
              <span className="landing-gradient-text">knows where your money goes.</span>
            </h1>
            <p className="landing-copy">
              Track spending, scan receipts, compare months, and get practical AI insights from a
              focused expense dashboard built for everyday decisions.
            </p>

            <div className="landing-hero-actions">
              <button type="button" className="landing-button primary" onClick={openLogin}>
                Get Started
              </button>
              <button type="button" className="landing-button secondary" onClick={openDemo}>
                Explore Platform
              </button>
            </div>

            <div className="landing-trust-badges" aria-label="FinoraAI capabilities">
              <span>AI Insights</span>
              <span>OCR Receipt Scanner</span>
              <span>Smart Expense Tracking</span>
            </div>

            <section className="landing-metrics" id="reports">
              <div className="landing-metric">
                <strong>OCR</strong>
                <span>Receipt to expense flow</span>
              </div>
              <div className="landing-metric">
                <strong>AI</strong>
                <span>Monthly spending guidance</span>
              </div>
              <div className="landing-metric">
                <strong>Demo</strong>
                <span>Sample data, no setup</span>
              </div>
            </section>
          </section>

          <section className="ai-mesh-border" aria-label="FinoraAI dashboard preview">
            <div className="landing-dashboard-preview glass-card">
              <div className="preview-top">
                <div>
                  <h2>Financial Health</h2>
                  <p>May 2026 overview</p>
                </div>
                <span className="live-pill">Live AI</span>
              </div>

              <section className="preview-grid" id="ocr-scanner">
                <div className="preview-card">
                  <span>Total Spend</span>
                  <strong>{"\u20b9"}2,08,450</strong>
                  <div className="glow-line" />
                </div>
                <div className="preview-card">
                  <span>Top Category</span>
                  <strong>Food</strong>
                  <div className="glow-line" />
                </div>
              </section>

              <div className="preview-chart" aria-hidden="true">
                {[42, 68, 54, 88, 61, 76, 96].map((height, index) => (
                  <span
                    key={height + index}
                    className="preview-bar"
                    style={{ height: `${height}%` }}
                  />
                ))}
              </div>

              <section className="insight-card" id="ai-insights">
                <span className="insight-icon">AI</span>
                <div>
                  <strong>Smart recommendation</strong>
                  <p>
                    Food and transport are trending higher than last month. Review recurring
                    purchases and set category limits before the next week begins.
                  </p>
                </div>
              </section>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

export default LandingPage;
